import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client';

const GET_PRODUCT_FEES = gql`
  query productFees($id: ID!) {
    product(id: $id) {
      id
      fees {
        id
        name
        rateMode
        rateModeType
      }
    }
  }
`;

export default function useProductFeeOptions({ productId, fee, onCompleted = () => {}, onError = () => {} }) {
  const { loading, error, data } = useQuery(GET_PRODUCT_FEES, {
    variables: { id: productId },
    skip: !productId,
    onCompleted,
    onError
  });

  const selectOptions = data?.product?.fees
    ?.filter(fee => fee.rateModeType !== 'PREMIUM_PLUS')
    ?.filter(fee => fee.rateMode === 'FLAT')
    ?.filter(x => !fee || fee.id !== x.id)
    .map(fee => ({
      label: fee?.name,
      value: fee?.id
    }));

  return {
    productFees: data?.product?.fees,
    selectOptions,
    loading,
    error
  };
}
